<template>
  <div>
    <v-tabs v-model="selectedTab"
            class="rounded-lg white--text"
            background-color="secondary"
            active-class="primary"
            color="#FF8700">
      <v-tab @click="changeRoute(tab)" v-for="tab in tabs" class="white--text mr-2">{{tab.title}}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "AdjustmentTabs",
  data() {
    return {
    };
  },
  props: {
    type: {
      default: 'ia'
    },
  },
  computed: {
    selectedTab(){
      if(this.$route.name == 'AdjustmentForm' && this.type == 'ia') {
        return 0
      }
      if(this.$route.name == 'AdjustmentsList' && this.type == 'ia') {
        return 1
      }
      if(this.$route.name == 'AdjustmentForm' && this.type == 'oa') {
        return 2
      }
      if(this.$route.name == 'AdjustmentsList' && this.type == 'oa') {
        return 3
      }
    },
    tabs() {
      return [
        {title: 'ثبت رسید تعدیل انبار', key: 'form', type: 'ia'},
        {title: 'لیست رسید تعدیل انبار', key: 'list', type: 'ia'},
        {title: 'ثبت حواله تعدیل انبار', key: 'form', type: 'oa'},
        {title: 'لیست حواله تعدیل انبار', key: 'list', type: 'oa'},
      ]
    },
  },
  methods: {
    changeRoute(tab){
      let keys = {list: '/report/lists/adjustments/', form: '/panel/adjustment/form/'}
      this.$router.push(keys[tab.key] + tab.type)
    }
  }

};
</script>

<style scoped lang="scss">
</style>

